import React from 'react';
import { useCart } from '../context/CartContext';
import './Cart.css';

function Cart({ setCurrentSection }) {
  const { cartItems, removeFromCart, updateQuantity, getTotalPrice, clearCart } = useCart();

  if (cartItems.length === 0) {
    return (
      <div className="cart-section">
        <div className="empty-cart">
          <h2>Your Cart is Empty</h2>
          <p>Start shopping to add items to your cart!</p>
          <button 
            className="continue-shopping-btn"
            onClick={() => setCurrentSection('wrappers')}
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-section">
      <div className="cart-container">
        <h2>Shopping Cart</h2>
        
        <div className="cart-items">
          {cartItems.map((item) => (
            <div key={item.id} className="cart-item">
              <div className="item-image">{item.image}</div>
              <div className="item-details">
                <h3>{item.name}</h3>
                <p>${item.price.toFixed(2)}</p>
              </div>
              
              <div className="quantity-control">
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                <input 
                  type="number" 
                  value={item.quantity}
                  onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                  min="1"
                />
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
              </div>

              <div className="item-total">
                ${(item.price * item.quantity).toFixed(2)}
              </div>

              <button 
                className="remove-btn"
                onClick={() => removeFromCart(item.id)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>

        <div className="cart-summary">
          <div className="summary-row">
            <span>Subtotal:</span>
            <span>${getTotalPrice().toFixed(2)}</span>
          </div>
          <div className="summary-row">
            <span>Shipping:</span>
            <span className="shipping">Free</span>
          </div>
          <div className="summary-row total">
            <span>Total:</span>
            <span>${getTotalPrice().toFixed(2)}</span>
          </div>
        </div>

        <div className="cart-actions">
          <button 
            className="checkout-btn"
            onClick={() => setCurrentSection('checkout')}
          >
            Proceed to Checkout
          </button>
          <button 
            className="continue-btn"
            onClick={() => setCurrentSection('wrappers')}
          >
            Continue Shopping
          </button>
          <button 
            className="clear-btn"
            onClick={clearCart}
          >
            Clear Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;
